import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-table',
  templateUrl: './skeleton-table.component.html',
  styleUrls: ['./skeleton-table.component.css']
})
export class SkeletonTableComponent {
  @Input() columns: number = 7;
  @Input() rows: number = 6;
  @Input() headerHeight: string = '32px';
  @Input() bodyHeight: string = '32px';

  get totalCells(): number {
    return this.columns * this.rows;
  }

  trackByIndex(index: number): number {
    return index;
  }

  getHeightForRow(index: number): string {
    return index < this.columns ? this.headerHeight : this.bodyHeight;
  }
}
